import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';

const getNewTimeZone = () => {
    let optionState = getRegionalOptions();
    let { UserOptions } = getUserConfiguration();

    return optionState.selectedTimeZone || UserOptions.TimeZone;
};

export default getNewTimeZone;
